import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../multiLang/translationEN.json";
import translationHI from "../multiLang/translationHI.json";
import translationTE from "../multiLang/translationTE.json";
import translationGJ from "../multiLang/translationGJ.json";
import translationKN from "../multiLang/translationKN.json";
import translationTL from "./tranlationTL.json";
import translationSP from './translationSP.json'
import translationAR from './translationAR.json'
import translationBN from './translationBN.json'
import translatioCH from './translationCH.json'
import translationIN from './translationIN.json'
import translationKO from './translationKO.json'
import translationMA from './translationMA.json'
import translationML from './translationML.json'
import translationMT from './translationMT.json'
import translationRS from './translationRS.json'


const resources = {
  en: { translation: translationEN },
  hi: { translation: translationHI },
  gu: { translation: translationGJ },
  kn: { translation: translationKN },
  ta: { translation: translationTL },
  te: { translation: translationTE },
  es: { translation: translationSP },
  ar: { translation: translationAR },
  bn: { translation: translationBN },
  zh: { translation: translatioCH },
  id: { translation: translationIN },
  ko: { translation: translationKO },
  ms: { translation: translationMA },
  ml: { translation: translationML },
  mr: { translation: translationMT },
  ru: { translation: translationRS },
};
i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;